import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../styles/scss/Navbar.scss";

import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";

export default class NavbarComponent extends React.Component {
  render(): JSX.Element {
    return (
      <Navbar collapseOnSelect id="navbar" expand="sm" sticky="top">
        <Container fluid>
          <Navbar.Brand as={NavLink} to="/">
            Joshua Yuen
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav activeKey={location.pathname} className="me-auto">
              <Nav.Link id="navbar-about" as={NavLink} to="/about" eventKey="navbar-about">
                About
              </Nav.Link>
              <Nav.Link id="navbar-projects" as={NavLink} to="/projects" eventKey="navbar-projects">
                Projects
              </Nav.Link>
              <Nav.Link id="navbar-contact" as={NavLink} to="/contact" eventKey="navbar-contact">
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    );
  }
}
